{
  "language": {
    "select": "Alterar idioma",
    "saveError": "Não foi possível salvar seu idioma no perfil."
  },
  "dateRangePicker": {
    "placeholder": "Selecione o período",
    "dateFormat": "dd 'de' LLL"
  },
  "toast": {
    "error": "Erro",
    "success": "Sucesso"
  },
  "whatsApp": {
    "ariaLabel": "Fale conosco no WhatsApp",
    "tooltip": "Fale conosco"
  },
  "loader": {
    "loading": "Carregando...",
    "preparing": "Preparando uma experiência incrível...",
    "loadingVideo": "Carregando player de vídeo...",
    "calculatingStats": "Calculando estatísticas",
    "analyzingProgress": "Analisando seu progresso...",
    "pleaseWait": "Aguarde um momento...",
    "navigating": "Navegando..."
  },
  "notifications": {
    "reasons": {
      "lessonCompleted": "Completou uma aula",
      "moduleCompleted": "Completou um módulo",
      "courseCompleted": "Concluiu um curso",
      "commentPosted": "Postou um comentário",
      "dailyLogin": "Login diário",
      "streakBonus": "Bônus de sequência",
      "quizCompleted": "Completou um quiz",
      "certificateEarned": "Conquistou certificado",
      "exerciseCompleted": "Completou exercício",
      "projectSubmitted": "Enviou projeto",
      "helpColleague": "Ajudou um colega",
      "firstLesson": "Primeira aula completada",
      "communityPostCreated": "Criou um post na comunidade",
      "communityCommentCreated": "Comentou na comunidade",
      "communityPostLiked": "Curtiu um post na comunidade",
      "communityCommentLiked": "Curtiu um comentário",
      "communityMentioned": "Mencionado na comunidade",
      "courseStarted": "Iniciou um curso",
      "courseProgress": "Avançou no curso",
      "lessonFavorited": "Favoritou uma aula",
      "postLiked": "Curtiu um post",
      "postReplied": "Respondeu a um post",
      "postShared": "Compartilhou um post",
      "dailyChecklistBonus": "Bônus da Trifecta diária"
    },
    "timeAgo": {
      "now": "agora"
    },
    "grouped": {
      "title": "+{{points}} XP hoje",
      "message": "{{count}} ações pontuaram hoje"
    },
    "clickToView": "Clique para ver",
    "title": "Notificações",
    "newCount_one": "{{count}} nova",
    "newCount_zero": "{{count}} novas",
    "newCount_other": "{{count}} novas",
    "markAllRead": "Marcar lidas",
    "filters": {
      "all": "Todas",
      "unread": "Não lidas"
    },
    "loading": "Carregando...",
    "empty": {
      "unreadTitle": "Tudo em dia!",
      "allTitle": "Nenhuma notificação",
      "unreadDescription": "Você não tem notificações pendentes",
      "allDescription": "Suas notificações aparecerão aqui"
    }
  },
  "videoField": {
    "variants": {
      "mirroredRoot": {
        "name": "Raiz espelhada",
        "description": "Copa e raiz encontrando-se na linha do horizonte"
      },
      "particleCanopy": {
        "name": "Copa em partículas",
        "description": "Coluna de luz que floresce em partículas"
      },
      "waterMonolith": {
        "name": "Monólito na água",
        "description": "Escultura do símbolo refletida em água parada"
      }
    }
  },
  "gamifiedAvatar": {
    "title": "{{level}} - {{points}} XP"
  },
  "imageUpload": {
    "invalidType": "Por favor, selecione uma imagem",
    "tooLarge": "A imagem deve ter no máximo 5MB",
    "uploadError": "Erro ao fazer upload da imagem",
    "previewAlt": "Preview",
    "replace": "Trocar",
    "remove": "Remover",
    "uploading": "Enviando...",
    "dropzone": "Clique ou arraste uma imagem aqui",
    "hint": "JPG, PNG, GIF ou WebP até 5MB"
  },
  "colorPicker": {
    "color": "Cor",
    "hue": "Matiz",
    "hex": "Hex",
    "preview": "Preview",
    "currentColor": "Cor atual",
    "newColor": "Nova cor",
    "presets": "Cores predefinidas",
    "cancel": "Cancelar",
    "apply": "Aplicar"
  },
  "pwaDashboard": {
    "initializing": "Inicializando PWA...",
    "title": "Progressive Web App",
    "subtitle": "Configure e monitore recursos PWA da plataforma",
    "online": "Online",
    "offline": "Offline",
    "installed": "Instalado",
    "dismiss": "Dispensar",
    "install": {
      "title": "Instalação",
      "description": "Instale a aplicação para acesso rápido e recursos offline",
      "success": "Aplicação instalada com sucesso!",
      "available": "A aplicação pode ser instalada em seu dispositivo.",
      "button": "Instalar Aplicação",
      "notNow": "Agora não",
      "unavailable": "A instalação não está disponível neste momento.",
      "unavailableHint": "Isso pode acontecer se a aplicação já estiver instalada ou se o navegador não suportar instalação PWA.",
      "stats": {
        "promptsShown": "Prompts Exibidos",
        "installs": "Instalações",
        "dismissed": "Dispensados"
      }
    },
    "updates": {
      "title": "Atualizações",
      "description": "Mantenha a aplicação sempre atualizada",
      "newVersion": "Nova versão disponível!",
      "upToDate": "Aplicação atualizada",
      "lastCheck": "Última verificação: {{date}}",
      "neverChecked": "Nunca verificado",
      "updateNow": "Atualizar Agora",
      "checkForUpdates": "Verificar Atualizações",
      "info": "Informações da Atualização:",
      "status": "Status: {{status}}",
      "waiting": "Aguardando",
      "available": "Disponível",
      "size": "Tamanho: {{size}}",
      "changes": "Mudanças:"
    },
    "features": {
      "title": "Recursos PWA",
      "description": "Recursos avançados da aplicação web progressiva",
      "active": "Ativo",
      "inactive": "Inativo",
      "offline": {
        "name": "Modo Offline",
        "description": "Acesse conteúdo mesmo sem internet"
      },
      "push": {
        "name": "Notificações Push",
        "description": "Receba notificações importantes"
      },
      "backgroundSync": {
        "name": "Sincronização em Background",
        "description": "Sincronize dados automaticamente"
      }
    },
    "metrics": {
      "title": "Métricas de Uso",
      "totalInstalls": "Total de Instalações",
      "dailyActiveUsers": "Usuários Ativos (Hoje)",
      "retentionRate": "Taxa de Retenção",
      "offlineUsage": "Uso Offline",
      "updateSuccessRate": "Taxa de Sucesso de Atualizações"
    },
    "storage": {
      "title": "Armazenamento",
      "appCache": "Cache da Aplicação",
      "platforms": "Plataformas",
      "installs_one": "{{count}} instalação",
      "installs_zero": "{{count}} instalações",
      "installs_other": "{{count}} instalações",
      "refresh": "Atualizar Informações"
    },
    "security": {
      "title": "Segurança e Privacidade",
      "https": "Aplicação servida via HTTPS",
      "secure": "Seguro",
      "serviceWorker": "Service Worker ativo",
      "notice": "Todos os dados são armazenados localmente e criptografados. A aplicação funciona offline respeitando sua privacidade."
    }
  },
  "pwa": {
    "manifest": {
      "name": "Xtreed - Plataforma de Ensino",
      "description": "Plataforma completa de ensino em desenvolvimento",
      "shortcuts": {
        "courses": {
          "name": "Meus Cursos",
          "shortName": "Cursos",
          "description": "Acessar meus cursos"
        },
        "achievements": {
          "name": "Conquistas",
          "shortName": "Conquistas",
          "description": "Ver minhas conquistas"
        }
      }
    },
    "errors": {
      "initializationFailed": "Falha ao inicializar o PWA",
      "unknown": "Erro desconhecido",
      "installPromptUnavailable": "Prompt de instalação indisponível",
      "installFailed": "Falha na instalação",
      "updateCheckFailed": "Falha ao verificar atualizações",
      "skipWaitingFailed": "Falha ao aplicar a atualização",
      "serviceWorkerNotRegistered": "Service Worker não registrado",
      "workboxNotInitialized": "Workbox não inicializado",
      "notificationsNotSupported": "Notificações não suportadas",
      "notificationPermissionDenied": "Permissão de notificação negada"
    }
  },
  "coursePlaceholder": "Curso",
  "tenant": {
    "defaultName": "Área de Membros"
  },
  "gamificationWidget": {
    "nextLevel": "Próximo nível:",
    "xpToNext": "Faltam <strong>{{xp}} XP</strong>",
    "maxLevel": "Você chegou ao nível máximo. Continue somando XP para subir no ranking.",
    "earnXpHint": "Ganhe XP concluindo aulas, comentando e mantendo sua sequência de estudos.",
    "position": "Posição",
    "streak": "Sequência",
    "streakDays_one": "{{count}} dia",
    "streakDays_zero": "{{count}} dias",
    "streakDays_other": "{{count}} dias",
    "viewRanking": "Ver ranking"
  }
}
